import { profileService } from 'shared/services/profileService';
import { talentService } from 'shared/services/talentService';
import { uploadService } from 'shared/services/uploadService';

const { setSelectProfileMedia, setProfilePrimaryImage, unSelectProfileMedia } = profileService();
const { patchMultipleMedia, patchMediaTags, uploadMedia } = uploadService();
const { updateTalent } = talentService();

export const useGetPhotoEditorMutates = () => {
  const { mutateAsync: patchMultipleMediaAsync, isError: multipleMediaError } = patchMultipleMedia();
  const { mutateAsync: patchMediaTagsAsync } = patchMediaTags();
  const { mutateAsync: setSelectProfileMediaMutateAsync, isError: ProfileMediaMutateError } = setSelectProfileMedia();
  const { mutateAsync: bindToProfileMutate, isError: bindToProfileError } = setSelectProfileMedia();
  const { mutateAsync: uploadMediaMutateAsync, isError: UploadMediaError } = uploadMedia();
  const { mutateAsync: updateSkillAsync, isError: updateSkillError } = updateTalent();
  const { mutate: unselectMutate } = unSelectProfileMedia();

  return {
    patchMultipleMediaAsync,
    patchMediaTagsAsync,
    setSelectProfileMediaMutateAsync,
    bindToProfileMutate,
    uploadMediaMutateAsync,
    updateSkillAsync,
    unselectMutate,
    multipleMediaError,
    ProfileMediaMutateError,
    bindToProfileError,
    UploadMediaError,
    updateSkillError,
  };
};
